import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const getInitials = (name) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const ImageOrInitials = ({ src, alt, size = "small" }) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-8 h-8",
    large: "w-10 h-10",
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={`${sizeClasses[size]} rounded-full`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-gray-100 flex items-center justify-center text-secondary font-medium`}
    >
      {getInitials(alt)}
    </div>
  );
};

const AgencyTopAgentsCard = ({
  agencyTopAgents,
  agencyLoading,
  onAgentClick,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div className="bg-white rounded-lg p-6 border border-[#D6DBEA]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-base sm:text-lg font-bold text-[#222A35]">
          Your Top agents
        </h2>
        <Link
          to="/leaderboard"
          className="text-[#2283FF] text-xs sm:text-sm hover:text-blue-700"
        >
          View Leaderboard
        </Link>
      </div>
      <div className="space-y-4">
        {agencyLoading ? (
          [...Array(3)].map((_, index) => (
            <div
              key={`loading-${index}`}
              className="flex items-center justify-between border border-[#D6DBEA] p-4 sm:p-6 rounded-xl animate-pulse"
            >
              <div className="flex items-center gap-2 sm:gap-4">
                <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                <div>
                  <div className="h-5 bg-gray-200 rounded w-24 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-16"></div>
                </div>
              </div>
              <div className="h-6 bg-gray-200 rounded w-16"></div>
            </div>
          ))
        ) : agencyTopAgents && agencyTopAgents.length > 0 ? (
          agencyTopAgents.map((agent) => (
            <div
              key={agent.rank}
              className="flex items-center justify-between border border-[#D6DBEA] p-4 sm:p-6 rounded-xl"
            >
              <div
                onClick={() => {
                  if (agent?.agent?.id) {
                    onAgentClick(agent?.agent?.id);
                  }
                }}
                className="cursor-pointer flex items-center gap-2 sm:gap-4"
              >
                <span className="bg-[#F9F9F9] p-2 sm:p-4 rounded-full text-[#222A35] text-sm sm:text-base font-bold shadow-sm">
                  {agent.rank}
                </span>
                <ImageOrInitials
                  src={agent.agent?.image}
                  alt={agent.agent?.name || "Agent"}
                  size={isMobile ? "medium" : "large"}
                />
                <div>
                  <h3 className="font-bold text-[#222A35] text-base sm:text-lg">
                    {agent.agent?.name || "Agent"}
                  </h3>
                  <p className="text-xs sm:text-sm text-[#43526E]">
                    {agent.pitches || 0} Pitches
                  </p>
                </div>
              </div>
              <span className="px-3 py-1 bg-orange-100 text-orange-600 rounded-full text-xs font-medium">
                {agent.points || 0} pts
              </span>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-gray-500 border border-[#D6DBEA] p-6 rounded-xl">
            No top agents found
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyTopAgentsCard;
